import PropTypes from 'prop-types'
import React from 'react'
import classNames from 'classnames'

import Modal from '../../common/Modal'
import { ReactComponent as GolferIcon } from '../../../assets/images/common/icons/golfer-half-icon.svg'
import { ReactComponent as ExportIcon } from '../../../assets/images/common/communityLeaderboard/Export.svg'
import { ReactComponent as WarningIcon } from '../../../assets/images/common/icons/warning-icon.svg'


import classes from './ExportMembersModal.module.scss'

const ExportMembersModal = ({ exportUrl, exportError, clearExportResult }) => (
  <Modal
    isOpen={!!exportUrl || !!exportError}
    onClose={clearExportResult}
    className={classes.modal}
  >
    <main className={classNames(classes.content, 'd-flex align-items-center flex-column')}>
      {exportError ? (
        <>
          <WarningIcon className={classes.icon} />
          <h5 className='text-center font-weight-bold'>Oops, something went wrong...</h5>
          <p className='text-center'>Please try again.</p>
        </>
      ) : (
        <>
          <GolferIcon className={classes.icon} />
          <h4 className='font-weight-bold'>Members Exported</h4>
          <p className='text-center'>The results have been exported successfully,<br/> download the file to view.</p>

          <a className='btn btn-primary text-white px-4 font-weight-bold' href={exportUrl}>
            Download CSV <ExportIcon className={classes.exportIcon} />
          </a>
        </>
      )}
    </main>
  </Modal>
)

ExportMembersModal.propTypes = {
  exportUrl: PropTypes.string,
  exportError: PropTypes.bool,
  clearExportResult: PropTypes.func.isRequired,
}

export default ExportMembersModal
